export default __webpack_public_path__ + "static/media/la_capelle8.dd83ad67.jpg";